import React from "react";
import { useTranslation } from "react-i18next";

const BenefitChangedPrice = ({ notification }) => {
  const { t } = useTranslation();


  const benefitTitle = notification?.payload?.title || "";

  return (
    <>
      <h4 className="notification-title">
        {t("notification_benefit_changed_price_title", { benefitTitle })}
      </h4>
      <p className="notification-subtitle">
        {t("notification_benefit_changed_price_subtitle", { benefitTitle })}
      </p>
      <p className="subtitle-description">
        {t("notification_benefit_changed_price_description")}
      </p>
    </>
  );
};

export default BenefitChangedPrice;
